import { useEffect } from 'react'
import { Navigate, Outlet, Route, Routes, useLocation } from 'react-router-dom'

import AppLayout from '@/components/common/layout'
import ChamadoExternalRoutes from '@/features/chamados/routes/chamado.external.routes'
import ChamadoRoutes from '@/features/chamados/routes/chamado.routes'
import PersonRoutes from '@/features/clientes/routes/routes'
import ContractRoutes from '@/features/contratos/routes/routes'
import UserDashboardPage from '@/features/dashboard/pages/dashboard-page'
import DashboardPage_External from '@/features/dashboard/pages/dashboard-page-external'
import VistasRoutes from '@/features/equipamentos/routes/res-equipment-vista'
import EquipmentRoutes from '@/features/equipamentos/routes/routes'
import StorageRoutes from '@/features/estoque/routes/routes'
import FinanceiroRoutes from '@/features/financeiro/routes/routes'
import HomePage from '@/features/home/pages/home-page'
import { OrdemDetailsPublicPage } from '@/features/ordens/pages/ordem-details.public'
import OrderPanel from '@/features/ordens/pages/ordem-painel'
import OrderRoutes from '@/features/ordens/routes/ordem.routes'
import AssetRoutes from '@/features/patrimonios/routes/routes'
import { ProductInternalRoutes } from '@/features/produtos/routes/routes'
import MyPage from '@/features/sessao/pages/my-page'

import { ClientAuthOutlet, UserAuthOutlet } from './features/sessao/layouts'
import { ClientLogin, UserLogin } from './features/sessao/pages'
import UserRoutes from './features/usuarios/routes/routes'

export function AppRoutes() {
  const { pathname } = useLocation()
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return (
    <Routes>
      <Route path="/paineis" element={<Outlet />}>
        <Route path="ordens" element={<OrderPanel />} />
      </Route>
      <Route
        path="/publico/ordem/:hashId"
        element={<OrdemDetailsPublicPage />}
      />
      <Route path="/" element={<AppLayout />}>
        <Route index element={<HomePage />} />
        <Route path="entrar" element={<UserLogin />} />
        <Route path="entrar-externo" element={<ClientLogin />} />

        {/* Internal */}
        <Route path="app" element={<UserAuthOutlet />}>
          <Route index element={<Navigate to="dashboard" />} />
          <Route path="dashboard" element={<UserDashboardPage />} />
          <Route path="minha-pagina" element={<MyPage />} />
          <Route path="entity" element={<Outlet />}>
            <Route index element={<Navigate to="/app/dashboard" />} />
            <Route path="clientes/*" element={<PersonRoutes />} />
            <Route path="contratos/*" element={<ContractRoutes />} />
            <Route path="produtos/*" element={<ProductInternalRoutes />} />
            <Route path="equipamentos/*" element={<EquipmentRoutes />} />
            <Route path="vistas/*" element={<VistasRoutes />} />
            <Route path="patrimonios/*" element={<AssetRoutes />} />
            <Route path="chamados/*" element={<ChamadoRoutes />} />
            <Route path="ordens/*" element={<OrderRoutes />} />
            <Route path="estoques/*" element={<StorageRoutes />} />
            <Route path="usuarios/*" element={<UserRoutes />} />
            <Route path="financeiro/*" element={<FinanceiroRoutes />} />
          </Route>
          <Route path="*" element={<Navigate to="/app" />} />
        </Route>

        {/* External */}
        <Route path="externo" element={<ClientAuthOutlet />}>
          <Route index element={<DashboardPage_External />} />
          <Route path="*" element={<ChamadoExternalRoutes />} />
        </Route>

        {/* Any other route */}
        <Route path="*" element={<Navigate to="/" />} />
      </Route>
    </Routes>
  )
}
